<template>
  <confirm-modal
    ref="confirmModal"
    name="confirm-canvas-action"
    :callback="actionCallback"
    :confirm-message="actionMessage"
  />
</template>
<script>
import ConfirmModal from '@groovepages/gd-ui-kit/components/ConfirmModal';
export default {
  components: { ConfirmModal },
  data() {
    return {
      actionMessage: '',
      actionCallback: () => {}
    };
  },
  mounted() {
    this.$canvas.on('action-request', request => {
      this.actionMessage = request.message;
      this.actionCallback = request.callback;
      if( this.$refs.confirmModal )
        this.$refs.confirmModal.open();
    });
  }
};
</script>
